import React from 'react';
import { useLocation } from 'react-router-dom';
import { AccessDenied } from '../components/rbac/AccessDenied';

interface UnauthorizedLocationState {
  requiredPermissions?: { resource: string; action: string; scope?: string }[];
  requiredRoles?: string[];
}

const Unauthorized: React.FC = () => {
  const location = useLocation();
  const state = (location.state ?? {}) as UnauthorizedLocationState;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <AccessDenied
        requiredPermissions={state.requiredPermissions}
        requiredRoles={state.requiredRoles}
      />
    </div>
  );
};

export default Unauthorized;
